import { EHosts } from "libraries/enums/EHosts";
import { Yii } from "libraries/interfaces/Yii";

export interface IBookingActionConfiguration {
    onCreateBookingArray?: IBookingActionConfigurationItem[];
}

export interface IBookingActionConfigurationItem {
    conditionArray: IBookingActionConfigurationItemCondition[];
    before?: IBookingActionConfigurationItemActionIf;
    after?: IBookingActionConfigurationItemActionIf;
}

export interface IBookingActionConfigurationItemCondition {
    hostCode?: string;
    hasServiceArray?: boolean;
    isLowCostCompany?: boolean;
    hasAllAdtTravellersWithDob?: boolean;
}

export interface IBookingActionConfigurationItemActionIf {
    isTrueActionArray?: IBookingActionConfigurationItemAction[];
    isFalseActionArray?: IBookingActionConfigurationItemAction[];
}

export interface IBookingActionConfigurationItemAction {
    modifyRequest?: EModifyRequest;
    emitErrorMessage?: string;
}

export enum EConditionKey {
    isLowCostCompany = "isLowCostCompany",
    hasAllAdtTravellersWithDob = "hasAllAdtTravellersWithDob",
    hostCode = "hostCode",
    hasServiceArray = "hasServiceArray",
}

export enum EModifyRequest {
    insertServicesInRequest = "insertServicesInRequest",
    insertPaymentInRequest = "insertPaymentInRequest",
}

export const bookingActionConfiguration: IBookingActionConfiguration = {
    onCreateBookingArray: [
        {
            conditionArray: [
                {
                    isLowCostCompany: true,
                    hasAllAdtTravellersWithDob: false,
                },
            ],
            before: {
                isTrueActionArray: [
                    {
                        emitErrorMessage: Yii.t('wui-iqba-js', 'Merci de saisir des dates de naissance pour les voyageurs adultes.'),
                    }
                ]
            }
        },
        {
            conditionArray: [
                {
                    hostCode: EHosts.TRAVELFUSION,
                    hasServiceArray: false,
                },
            ],
            before: {
                isTrueActionArray: [
                    {
                        modifyRequest: EModifyRequest.insertServicesInRequest
                    }
                ]
            }
        },
        {
            conditionArray: [
                {
                    isLowCostCompany: true,
                },
            ],
            before: {
                isTrueActionArray: [
                    {
                        modifyRequest: EModifyRequest.insertPaymentInRequest
                    }
                ]
            }
        },

    ]
};
